import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import CancelIcon from '@material-ui/icons/Cancel'

import { PeopleActionTypes } from '../../store/people/peopleTypes'

import Card from '@material-ui/core/Card'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(5),

    background: '#fff',

    position: 'sticky',
    top: 0,
    minWidth: '275',
    zIndex: 9,
  },
  searchIcon: {
    color: '#888',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  cancelIcon: {
    color: '#ddd',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
}))

export default function PeopleListSearch() {
  const classes = useStyles()
  const [inputSearch, setInputSearch] = useState('')
  const dispatch = useDispatch()

  const onChangeInput = (e: any) => {
    const { value } = e.target
    setInputSearch(value)
  }

  const onClickClearSearch = () => {
    setInputSearch('')
  }

  /**
   * Apenas disparar a ação de pesquisa quando o usuário parar de digitar (debounce)
   */
  useEffect(() => {
    const debounced = setTimeout(dispatch, 300, {
      type: PeopleActionTypes.SET_SEARCH_QUERY,
      searchQuery: inputSearch,
    })
    return () => clearTimeout(debounced)
  }, [inputSearch, dispatch])

  return (
    <>
      <Card className={classes.root}>
        <SearchIcon className={classes.searchIcon} />
        <InputBase
          className={classes.input}
          placeholder="Pesquisar..."
          onChange={onChangeInput}
          value={inputSearch}
          autoComplete="new-password" // hack para desativar preenchimento automático
        />
        {!!inputSearch ? (
          <IconButton onClick={onClickClearSearch}>
            <CancelIcon className={classes.cancelIcon} />
          </IconButton>
        ) : (
          <div>
            <p style={{ padding: 24 }} />
          </div>
        )}
      </Card>
      <Divider />
    </>
  )
}
